import { makeActionCreatorV2 } from '../../actions';

import { moduleId } from './config';

export const clearSiteIdBeforeChange = makeActionCreatorV2(
  'CLEAR_SITE_ID_BEFORE_CHANGE',
  'clearSiteId',
  moduleId
);
